import axios from "axios";
import { useAdminStore } from "../../stores/admin-store";
import { getRouteSignIn } from "../const/router";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3000/api/v1";

const $api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" }
});

$api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      useAdminStore.getState().clearUser();
      window.location.href = getRouteSignIn();
    }
    return Promise.reject(error);
  }
);

export default $api;
